import qs from 'qs';
import client from './client';

const BASE_URL = '/api/v1/shipmentmng';
const CANDIDATE_BASE_URL = '/api/v1/shipment/candidates';

// 출고 목록 조회
export const getShipmentList = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${BASE_URL}/list?${queryString}`);
};

// 출고 상세 조회 (마스터 + 상세 + 이력)
export const getShipment = (shipmentId) => {
  return client.get(`${BASE_URL}/${shipmentId}`);
};

// 출고 등록
/**
 * 프로젝트 것으로 잡힌, 출고할 수 있는 창고 재고.
 * 출고관리에서 프로젝트를 고르면 이 목록에서 담는다.
 */
export const getShippableStock = (prjUuid) =>
  client.get(`${BASE_URL}/shippable-stock/${prjUuid}`);

export const createShipment = (data) => {
  return client.post(BASE_URL, data);
};

// 출고 수정
export const updateShipment = (shipmentId, data) => {
  return client.put(`${BASE_URL}/${shipmentId}`, data);
};

// 출고 상태 변경
export const updateShipmentStatus = (shipmentId, statusData) => {
  return client.put(`${BASE_URL}/${shipmentId}/status`, statusData);
};

// 출고 삭제
export const deleteShipment = (shipmentId) => {
  return client.delete(`${BASE_URL}/${shipmentId}`);
};

// 출고 이력 조회
export const getShipmentHistory = (shipmentId) => {
  return client.get(`${BASE_URL}/${shipmentId}/history`);
};

// 출고 현황 요약
export const getShipmentSummary = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${BASE_URL}/summary?${queryString}`);
};

// 출하대상 목록 조회
export const getShipmentCandidates = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${CANDIDATE_BASE_URL}?${queryString}`);
};

// 출하대상 상세 조회
export const getShipmentCandidate = (candidateId) => {
  return client.get(`${CANDIDATE_BASE_URL}/${candidateId}`);
};

// 거래명세표 출력 데이터. 양식 채우기는 화면에서 한다.
/**
 * 여러 출고를 한 장으로 묶은 명세표 데이터.
 * 고객사가 다르면 서버가 거절한다.
 */
export const getBundledStatement = (shipmentIds) =>
  client.post(`/api/v1/shipment/statements/bundle`, { shipmentIds });

export const getShipmentStatement = (shipmentId) =>
  client.get(`/api/v1/shipment/statements/${shipmentId}`);

// 실제로 내려받은 뒤 호출한다. 재발급 여부를 남기기 위한 것이다.
export const markStatementIssued = (shipmentId) =>
  client.post(`/api/v1/shipment/statements/${shipmentId}/issued`);

// 리마인드를 기한까지만 멈춘다. 읽음과 다르다 — 읽음은 알림 한 줄을 치울 뿐 다음 주기에 또 온다.
export const snoozeShipmentCandidate = (candidateId, days) => {
  return client.post(`${CANDIDATE_BASE_URL}/${candidateId}/snooze`, { days });
};

// 영구 무시. 사유는 서버에서 필수다.
export const ignoreShipmentCandidate = (candidateId, reason) => {
  return client.post(`${CANDIDATE_BASE_URL}/${candidateId}/ignore`, { reason });
};

// 여러 건을 한 번에 그만 받기. 같은 사유로 묶어 끈다.
export const ignoreShipmentCandidates = (candidateIds, reason) => {
  return client.post(`${CANDIDATE_BASE_URL}/ignore-bulk`, { candidateIds, reason });
};

// 무시·스누즈를 풀고 다시 알림을 받는다.
export const resumeShipmentCandidateNotification = (candidateId) => {
  return client.post(`${CANDIDATE_BASE_URL}/${candidateId}/resume-notification`);
};

// 거래명세표 발급/재발급
export const issueStatement = (shipmentId) => {
  return client.post(`${BASE_URL}/${shipmentId}/statement`);
};

// 최근 거래명세표 조회
export const getLatestStatement = (shipmentId) => {
  return client.get(`${BASE_URL}/${shipmentId}/statement/latest`);
};

// 거래명세표 다운로드/미리보기
export const downloadStatement = (shipmentId, docId, params = {}) => {
  const queryString = qs.stringify(params);
  return client.get(`${BASE_URL}/${shipmentId}/statement/${docId}/download?${queryString}`, {
    responseType: 'blob',
  });
};
